import {
  AimOutlined,
  BookOutlined,
  FileExcelOutlined,
  FileMarkdownOutlined,
  FilePptOutlined,
  FolderOutlined,
  HomeOutlined,
  TeamOutlined,
} from '@ant-design/icons'
import qs from 'query-string'
import React from 'react'

import { CustomerContainer } from '@/modules/customer/customer.container'
import { DevlopContainer } from '@/modules/devlop/devlop.container'
import { OKRContainer } from '@/modules/okr'
import { PersonalContainer } from '@/modules/personal'
import { PortfolioContainer } from '@/modules/portfolio'
import { ProductionContainer } from '@/modules/production-project/production.container'
import { ProjectContainer } from '@/modules/project'
import { TeamContainer } from '@/modules/team'

const parameterfy = (params?: Record<string, any>) => (params ? '?' + qs.stringify(params) : '')

export const routes = {
  personal: {
    home: () => '/personal',
  },

  project: {
    home: () => '/project',
    page: (selfId: string, params?: Record<'tab', string | number>) => `/project/${selfId}` + parameterfy(params),
    create: () => `/project/create`,
  },

  portfolio: {
    home: () => '/portfolio',
    page: (selfId: string) => `/portfolio/${selfId}`,
    create: () => `/portfolio/create`,
  },

  team: {
    home: (params?: Record<'departmentId', any>) => '/team' + parameterfy(params),
  },

  okr: {
    home: () => '/okr',
  },

  customer: {
    home: '/customer',
    create: '/customer/create',
    detail: (selfId: string, params?: Record<'tab', string | number>) => `/customer/${selfId}` + parameterfy(params),
  },

  production: {
    home: '/production',
    create: '/production/create',
    detail: (selfId: string, params?: Record<'tab', string | number>) => `/production/${selfId}` + parameterfy(params),
  },

  devlop: {
    home: '/devlop',
    create: '/devlop/create',
    detail: (selfId: string, params?: Record<'tab', string | number>) => `/devlop/${selfId}` + parameterfy(params),
  },

  resource: {
    home: () => '/resource',
  },
}

export const routerConfig = [
  {
    path: routes.personal.home(),
    title: '我的个人页',
    component: PersonalContainer,
    icon: <HomeOutlined />,
    hasContainer: true,
  },
  {
    path: routes.project.home(),
    title: '普通项目',
    component: ProjectContainer,
    icon: <BookOutlined />,
    hasContainer: true,
  },
  {
    path: routes.portfolio.home(),
    title: '普通项目组合',
    component: PortfolioContainer,
    icon: <FolderOutlined />,
    hasContainer: true,
  },
  {
    path: routes.team.home(),
    title: '团队管理',
    component: TeamContainer,
    icon: <TeamOutlined />,
    hasContainer: true,
  },
  {
    path: routes.okr.home(),
    title: 'OKR & 项目',
    component: OKRContainer,
    icon: <AimOutlined />,
    hasContainer: false,
  },
  {
    path: routes.customer.home,
    title: '客户项目',
    component: CustomerContainer,
    icon: <FileMarkdownOutlined />,
    hasContainer: true,
  },
  {
    path: routes.production.home,
    title: '产品项目',
    component: ProductionContainer,
    icon: <FilePptOutlined />,
    hasContainer: true,
  },
  {
    path: routes.devlop.home,
    title: '研发项目',
    component: DevlopContainer,
    icon: <FileExcelOutlined />,
    hasContainer: true,
  },
]
